import React from "react";

const CrossIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.31494 9.69752L9.07058 1.35188"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9.58977 9.49359L1.42315 1.55565"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default CrossIcon;
